/* global google */
'use strict';

/**
 * Google Map Function
 */
const googleMap = (el, options) => {
	options = JSON.parse(options);

	if (options.locations) {
		options.locations = Object.values(options.locations);
	}
	if (!el) return;

	const defaultOptions = {
		'lat': '37.979561',
		'lng': '23.728487',
		'zoom': 13,
		'styles': '',
		'places_categories': false,
		'locations': [{
			lat: -33.890542,
			lng: 151.274856,
			address: '',
			tooltip: false,
			marker_svg: false,
			marker_svg_file: false,
			marker_svg_size_width: 40,
			marker_svg_size_height: 80,
			image_src: '',
			image_alt: '',
			info_title: '',
			info_text: '',
			info_btn: '',
			info_btn_url: '',
			info_btn_target: ''
		}]
	};

	let settings = {...defaultOptions, ...options};

	let markers = [];
	let bounds = new google.maps.LatLngBounds();

	const navBar = document.querySelector('nav.navbar');

	let offsetHeight = navBar ? navBar.offsetTop: 0;

	let map = new google.maps.Map(el, {
		zoom: settings.zoom,
		zoomControl: true,
		scaleControl: false,
		scrollwheel: false,
		styles: settings.styles ? settings.styles : '',
		streetViewControl: false,
		disableDoubleClickZoom: true,
		mapTypeControl: false,
		fullscreenControl: false
	});

	[...settings.locations].map(location => {
		let locLatLng = new google.maps.LatLng(location.lat, location.lng);
		let infoButtonString = '';
		let infoImageUrl = '';
		let markerInfowindow = false;
		let icon = false;

		if (location.info_btn_url) {
			infoButtonString = '<p><a href="' + location.info_btn_url + '" target="' + location.info_btn_target + '">' + location.info_btn + '</a></p>';
		}

		if (location.image_src) {
			infoImageUrl = '<div class="side-gmap"><img src="' + location.image_src + '" alt="' + location.image_alt + '" /></div>';
		}

		if (location.marker_svg_file) {
			icon = {
				url: location.marker_svg_file,
				scaledSize: new google.maps.Size(location.marker_svg_size_width || 40, location.marker_svg_size_height || 80),
				anchor: new google.maps.Point(location.marker_svg_size_width / 2, location.marker_svg_size_height),
			};
		}

		if (location.info_text || location.info_title) {
			let contentString =
				'<div class="map-infowindow">' +
				infoImageUrl +
				'<div class="main-gmap">' +
				'<h3 class="text-dark">' + location.info_title + '</h3>' +
				'<div class="text-dark">' + location.info_text + infoButtonString + '</div>' +
				'</div>' +
				'</div>';

			markerInfowindow = new google.maps.InfoWindow({
				content: contentString
			});
		}

		let marker = new google.maps.Marker({
			position: locLatLng,
			map: map,
			icon: icon ? icon : '',
			draggable: false,
			zIndex: -20,
			infowindow: markerInfowindow ? markerInfowindow : false,
		});

		markers.push(marker);

		marker.addListener('click', function () {
			hideAllInfoWindows(map);
			if (this.infowindow) {
				this.infowindow.open(map, this);
			}
			map.setCenter(this.getPosition());
			map.panTo(this.getPosition());

			if (offsetHeight) {
				map.panBy(0, -offsetHeight);
			}
		});

		map.panTo(marker.getPosition());

		if (offsetHeight && window.innerWidth > 768) {
			map.panBy(0, -offsetHeight);
		}

		bounds.extend(locLatLng);
	});

	map.setZoom(settings.zoom);
	if (Object.keys(settings.locations).length > 1) {
		map.fitBounds(bounds);
	}

	function hideAllInfoWindows(map) {
		markers.forEach(function (marker) {
			if (marker.infowindow) {
				marker.infowindow.close(map, marker);
			}
		});
	}
};

/**
 * Initialise every .map element on the page.
 */
const initAllMaps = () => {
	Array.from(document.querySelectorAll('.map')).map(el => googleMap(el, el.dataset.json));
};

/**
 * Runs `onReady` only once the Google Maps JS API is actually usable.
 *
 * The API is enqueued asynchronously by the parent theme (enqueue.php) —
 * either via the `importLibrary` bootstrap loader or a plain `<script async>`
 * tag — so `google.maps` is usually NOT available when this bundled script
 * executes. Calling `new google.maps.Map()` too early throws and the map
 * never renders. This gate is mode-agnostic and race-free for both loading
 * strategies.
 *
 * @param {CallableFunction} onReady
 */
const whenGoogleMapsReady = (onReady) => {
	// Modern loader: importLibrary is defined synchronously by the bootstrap.
	// Awaiting it both loads and populates the google.maps.* namespace
	// (Map, Marker, InfoWindow, LatLng, LatLngBounds, Size, Point, ...).
	if (window.google && google.maps && typeof google.maps.importLibrary === 'function') {
		Promise.all([
			google.maps.importLibrary('maps'),
			google.maps.importLibrary('marker'),
			google.maps.importLibrary('core'),
		]).then(onReady);
		return;
	}

	// Classic async script that has already finished loading.
	if (window.google && google.maps && google.maps.Map) {
		onReady();
		return;
	}

	// Async script not loaded yet — poll briefly until it is (max ~15s).
	let tries = 0;
	const timer = setInterval(() => {
		tries++;
		if (window.google && google.maps && (google.maps.Map || typeof google.maps.importLibrary === 'function')) {
			clearInterval(timer);
			whenGoogleMapsReady(onReady);
		} else if (tries > 150) {
			clearInterval(timer);
		}
	}, 100);
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => whenGoogleMapsReady(initAllMaps));
} else {
	whenGoogleMapsReady(initAllMaps);
}
